import { query, mutation } from '@/dex-shared/helpers/graphql';

export default {
  state: {
    institutions: [],
    institution: null,
  },
  getters: {
    currentInstitution: (state: any) => {
      return state.institution;
    },
  },
  mutations: {
    SET_INSTITUTION(state: any, institution: any) {
      state.institution = institution;
    },
    SET_EMPTY_INSTITUTION(state: any) {
      let institution = {
        id: null,
        title: '',
      };
      state.institution = institution;
    },
    REMOVE_QUESTION(state: any, index: number) {
      state.questions.splice(index, 1);
    },
  },
  actions: {
    async PULL_INSTITUTION({ commit }: any, institutionId: number) {
      let response = await query(
        `query pullInstitution ($institutionId: Int!) {
        institutionById(id: $institutionId) {
          id
          title
        }
      }`,
        {
          institutionId,
        },
      );
      if (response.data.institutionById) {
        commit('SET_INSTITUTION', response.data.institutionById);
      }
    },

    async PUSH_INSTITUTION({ commit, rootState }: any, institution: any) {
      let userId = rootState.auth.user ? rootState.auth.user.id : null;
      const acronym = institution.acronym || '';
      const stateAcronym = institution.stateAcronym || null;
      let response;
      let institutionResponse;
      if (institution.id != null) {
        response = await mutation(
          `mutation updateInstitution ($institutionId: Int!, $title: String!, $acronym: String, $stateAcronym: Statesenum) {
              updateInstitutionById(
                input: {
                  id: $institutionId,
                  institutionPatch:{
                    title: $title
                    acronym: $acronym,
                    stateAcronym: $stateAcronym
                  }
                }
              ){
                institution {
                  id
                  title
                  acronym
                  stateAcronym
                }
              }
            }`,
          {
            institutionId: institution.id,
            title: institution.title,
            acronym,
            stateAcronym,
          },
        );
        institutionResponse = response.data.updateInstitutionById.institution;
      } else {
        response = await mutation(
          `mutation createInstitution ($userId: Int!, $title: String!, $acronym: String, $stateAcronym: Statesenum) {
              createInstitution(
                input: {
                  institution: {
                    userId: $userId,
                    title: $title,
                    acronym: $acronym,
                    stateAcronym: $stateAcronym
                  }
                }
              ) {
                institution {
                  id
                  title
                  acronym
                  stateAcronym
                }
              }
            }`,
          {
            userId: userId,
            title: institution.title,
            acronym,
            stateAcronym,
          },
        );
        institutionResponse = response.data.createInstitution.institution;
      }
      //TODO error inputing institution

      if (institutionResponse != null) {
        commit('SET_INSTITUTION', institution);
      }
    },
  },
};
